import { render } from "./ReportPage.vue?vue&type=template&id=260934d5&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "./ReportPage.vue?vue&type=style&index=0&id=260934d5&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260934d5"],['__file',"src/components/reports/toxicology/ReportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "260934d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('260934d5', __exports__)) {
    console.log('reload')
    api.reload('260934d5', __exports__)
  }
  
  module.hot.accept("./ReportPage.vue?vue&type=template&id=260934d5&scoped=true", () => {
    console.log('re-render')
    api.rerender('260934d5', render)
  })

}


export default __exports__